export default __webpack_public_path__ + "static/media/Tools-P6-CIFOR.7be626d3.jpg";